import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@draeger-academy/common';
import { DwVideoModule } from '../video';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { MediaTeaserBoxComponent } from './media-teaser-box.component';

@NgModule({
    declarations: [MediaTeaserBoxComponent],
    exports: [MediaTeaserBoxComponent],
    imports: [CommonModule, DaLinkModule, DaButtonModule, DaProgressiveImageModule, PipesModule, DwVideoModule, RouterModule]
})
export class MediaTeaserBoxModule {
    constructor() {}
}
